<script setup>
import { computed, nextTick, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useMapGetter, useStore } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';
import Dialog from 'next/dialog/Dialog.vue';

const emit = defineEmits(['close']);
const { t } = useI18n();
const store = useStore();

const report = ref({});
const dialogRef = ref(null);
const isOpen = ref(false);
const uiFlags = useMapGetter('wgptCustomReports/getUIFlags');

const description = computed(() =>
  t('WGPT_CUSTOM_REPORTS.DELETE.CONFIRM_MESSAGE', {
    reportName: report.value.name,
  })
);

const open = targetReport => {
  report.value = targetReport;
  isOpen.value = true;
  nextTick(() => dialogRef.value?.open());
};

const close = () => {
  dialogRef.value?.close();
  isOpen.value = false;
  emit('close');
};

const handleDialogConfirm = async () => {
  try {
    await store.dispatch('wgptCustomReports/delete', report.value.id);
    useAlert(t('WGPT_CUSTOM_REPORTS.DELETE.SUCCESS'));
    close();
  } catch (error) {
    useAlert(error?.message || t('WGPT_CUSTOM_REPORTS.DELETE.ERROR'));
  }
};

defineExpose({ open, close });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="alert"
    :title="t('WGPT_CUSTOM_REPORTS.DELETE.CONFIRM_TITLE')"
    :description="description"
    :confirm-button-label="t('WGPT_CUSTOM_REPORTS.DELETE.CONFIRM_YES')"
    :cancel-button-label="t('WGPT_CUSTOM_REPORTS.DELETE.CONFIRM_NO')"
    :is-loading="uiFlags.isDeleting"
    @confirm="handleDialogConfirm"
  />
</template>
